/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S6_IntroInputs */

const tr_servis_s6_intro = /** @type {(inputs: Servis_S6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri talepleri kvkk@emonse.com adresine iletilir. Önceden kabul edilmiş bir sözleşme aşağıdaki biçimlerde dışa aktarma hakkı tanıyorsa bu hak saklıdır:`)
};

const en_servis_s6_intro = /** @type {(inputs: Servis_S6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send data requests to kvkk@emonse.com. If a previously accepted contract grants export rights in the following formats, those rights remain valid:`)
};

const de_servis_s6_intro = /** @type {(inputs: Servis_S6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenanfragen richten Sie an kvkk@emonse.com. Gewährt eine bereits angenommene Vertragsfassung einen Export in den folgenden Formaten, bleibt dieser Anspruch bestehen:`)
};

const ru_servis_s6_intro = /** @type {(inputs: Servis_S6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросы данных направляются на kvkk@emonse.com. Если ранее принятый договор предоставляет экспорт в следующих форматах, это право сохраняется:`)
};

/**
* | output |
* | --- |
* | "Send data requests to kvkk@emonse.com. If a previously accepted contract grants export rights in the following formats, those rights remain valid:" |
*
* @param {Servis_S6_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s6_intro = /** @type {((inputs?: Servis_S6_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S6_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s6_intro(inputs)
	if (locale === "de") return de_servis_s6_intro(inputs)
	if (locale === "ru") return ru_servis_s6_intro(inputs)
	return tr_servis_s6_intro(inputs)
});